import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';
import styled, { ThemeContext } from 'styled-components';
import ROUTES, { getRouteWithParam } from '../../../common/helpers/routes';

export const StyledLink = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 48px;
`;

const AccountCreationLink = () => {
  const theme = useContext(ThemeContext);
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const isp = searchParams.get('isp');

  const route = getRouteWithParam(ROUTES.home, 'isp', isp);

  return (
    <StyledLink>
      <Link data-test="create_test_account_link" to={route} style={{ color: theme.colors.primary.regular }}>
        <FormattedMessage
          id="developer.success.page.create.account.button"
          defaultMessage="Create another test account"
        />
      </Link>
    </StyledLink>
  );
};

export default AccountCreationLink;
